<EmptyHeader />

<ContainerWithGap>
    {#if showRegister }
        <Register
            {newAccountWithEmailEnrollmentUrl}
            {showCreateAccountUsingAnotherSite}
            {showCreateAccountUsingEmail}
            on:finished={onRegistrationPageClosed}
            {i18n}
            {antiForgery}
            {courseId}
            {currentCustomerId}
        />
    {:else}
        <CourseCatalogueInfo
            backLinkUrl={backLinkUrl}
            courseInfo={{ title, code, content, imageUrl, teachers, subject, educationalLevel, targetRole, courseInternalUrl, organisation }}
            displayOptions={{
                showEnrolButton: enrolButtonIsVisible,
                showWithdrawButton: false,
                showShareButton: !!courseUrl,
                showCancelEnrollmentButton: false,
                showAvailableExternally: false,
                showLinkToCourse: false,
                showExternalEnrollmentApplicationSuccess: isExternalEnrollmentApplicationSuccess,
                showTeachersOnlyBanner: catalogueAccess === 'TeachersOnly',
                showStudentsOnlyBanner: catalogueAccess === 'StudentsOnly',
                banner
            }}
            bind:messages={messages}
            on:enrol={enrol}
            on:share={share}
            {i18n}
        />
    {/if}
</ContainerWithGap>

<SharingModal
    bind:enabled={shareModalEnabled}
    publicLink={courseUrl}
    objectName={title}
    i18n={i18n.sharingModalTerms}
/>

<script>
    import ContainerWithGap from '@its-ui/common-components/ContainerWithGap/ContainerWithGap.svelte';
    import CourseCatalogueInfo from "@its-ui/common-components/CourseCatalogueInfo/CourseCatalogueInfo.svelte";
    import EmptyHeader from '@itslearning/prometheus/assets/nodes/EmptyHeader/v1/EmptyHeader.svelte';
    import SharingModal from "@its-ui/common-components/SharingModal/SharingModal.svelte";
    import Register from "../Register/Register.svelte";
    import { measureKpi } from '../../api.js';
    import { MEASUREMENTS } from '../../constants';

    export let i18n;
    /** @type {import('../../api.js').AntiForgery} */
    export let antiForgery;
    export let backLinkUrl;
    export let title;
    export let code;
    export let courseId;
    export let content = '';
    export let imageUrl = '';
    /** @type {import('../../api.js').CatalogueCourseTeacherModel[]}*/
    export let teachers;
    export let courseUrl = '';
    export let courseBackUrl = '';
    export let subject = '';
    export let educationalLevel = '';
    export let targetRole = '';
    export let organisation = '';
    export let currentCustomerId;
    export let courseInternalUrl = '';
    export let showCreateAccountUsingAnotherSite = false;
    export let showCreateAccountUsingEmail = false;
    export let isExternalEnrollmentApplicationSuccess = false;
    export let banner = '';
    export let enrolmentStatus = '';
    export let catalogueAccess = '';
    export let showEnrolButton = true;

    let shareModalEnabled = false;
    let showRegister = false;
    let enrolButtonIsVisible = !isExternalEnrollmentApplicationSuccess 
        && (!banner || banner === 'AccessExpired') 
        && enrolmentStatus !== 'NoSeatsAvailable'
        && showEnrolButton !== false;

    let newAccountWithEmailEnrollmentUrl = `/courses/catalogue/external/${courseId}/enrol/newaccountwithemail?backUrl=${encodeURIComponent(courseBackUrl)}`;
    let messages = { info: '', error: '' };
    if (enrolmentStatus === 'NoSeatsAvailable')
    {
        messages.info = i18n.noSeatsAvailable;
    }

    function enrol() {
        measureKpi(MEASUREMENTS.EnrollInExternalCourse, antiForgery);
        showRegister = true;
    }

    function share() {
        shareModalEnabled = true;
    }

    function onRegistrationPageClosed() {
        showRegister = false;
    }
</script>
